import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { FadeIn } from './ui/FadeIn';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-115">
      {/* Decorative background blob */}
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-[800px] h-[800px] bg-light-terra rounded-full blur-3xl opacity-50 -z-10 pointer-events-none" data-id="element-116"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-118">
          <div className="max-w-2xl" data-id="element-119">
            <FadeIn direction="up" data-id="element-120">
              <span className="inline-block py-1 px-3 rounded-full bg-light-sage text-sage font-semibold text-sm tracking-wide mb-6" data-id="element-121">
                Para la mujer que lo hace todo
              </span>
            </FadeIn>

            <FadeIn delay={100} direction="up" data-id="element-122">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-olive" data-id="element-123">
                Deja de pedir perdón por tu casa: El Método de Limpieza de 15
                Minutos.
              </h1>
            </FadeIn>

            <FadeIn delay={200} direction="up" data-id="element-124">
              <p className="text-lg md:text-xl text-olive/80 mb-8 leading-relaxed" data-id="element-125">
                Recupera tu paz mental y recibe visitas sin pánico con el
                sistema de{' '}
                <strong className="text-terra font-semibold" data-id="element-126">
                  "Triaje Doméstico"
                </strong>{' '}
                diseñado para agendas imposibles.
              </p>
            </FadeIn>

            <FadeIn delay={300} direction="up" data-id="element-127">
              <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-128">
                <CTAButton href="https://temptbeuty.com/cart/56849035231392:1" className="w-full sm:w-auto text-lg" data-id="element-129">
                  ¡Sí, quiero mi casa bajo control!
                </CTAButton>
                <span className="text-sm text-olive/60 font-medium px-2" data-id="element-130">
                  Acceso Inmediato
                </span>
              </div>
            </FadeIn>
          </div>

          <div className="relative lg:ml-auto" data-id="element-131">
            <FadeIn delay={400} direction="left" data-id="element-132">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-olive/10 border-8 border-white transform -rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-133">
                <img src="https://cdn.magicpatterns.com/uploads/jfWyzBcQchUjqNLYLEggVG/Mock_up_Clean_Slate.png" alt="Clean Slate Latina Digital Guide on iPad and iPhone" className="w-full h-auto object-cover" data-id="element-134" />
              </div>
              {/* Decorative elements around image */}
              <div className="absolute -bottom-6 -left-6 w-24 h-24 bg-light-sage rounded-full -z-10" data-id="element-135"></div>
              <div className="absolute -top-6 -right-6 w-16 h-16 bg-terra/20 rounded-full -z-10" data-id="element-136"></div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}